import axios from "../plugins/parseAxios";
export class ContractAPI {
  constructor(props) {}
  static getContracts(payload) {
    return axios.post("functions/getContracts", payload);
  }
  static createContract(payload) {
    return axios.post("functions/createContract", payload);
  }
  static renewContract(payload) {
    return axios.post("functions/renewContract", payload);
  }
  static getContract(payload) {
    return axios.post("functions/getContract", {
      id: payload.id
    });
  }
  static getContractsByCustomer(payload) {
    return axios.post("functions/getContractsByCustomer", payload);
  }
  static updateContract(payload) {
    return axios.post("functions/updateContract", payload);
  }
  static addContractArea(payload) {
    return axios.post("functions/addContractArea", payload);
  }
  static removeContractArea(payload) {
    return axios.post("functions/removeContractArea", payload);
  }
  static getNewContractsBetweenDateByMarket(marketId, startDate, endDate) {
    return axios.post("functions/getNewContractsBetweenDateByMarket", {
      marketId,
      startDate,
      endDate
    });
  }
  static getContractsBetweenDateByMarket(marketId, startDate, endDate) {
    return axios.post("functions/getContractsBetweenDateByMarket", {
      marketId,
      startDate,
      endDate
    });
  }
  static getActiveContractsBetweenDateByMarket(marketId, startDate, endDate) {
    return axios.post("functions/getActiveContractsBetweenDateByMarket", {
      marketId,
      startDate,
      endDate
    });
  }
  static getActiveContractByMarket(formData) {
    return axios.post("functions/getActiveContractByMarket", formData);
  }
  static getContractWillExpiredByMarket(formData) {
    return axios.post("functions/getContractWillExpiredByMarket", formData);
  }
}
